import { useTranslation } from "../i18n";

interface IProps {
  url: string;
  style?: React.CSSProperties;
}

const defaultStyle: React.CSSProperties = {
  display: "inline-block",
  padding: "0 20px",
  fontSize: "12px",
  height: 30,
  lineHeight: "30px",
  color: "#1A1A1B",
  backgroundColor: "#FFE804",
  borderRadius: 18,
  fontWeight: 600,
  marginLeft: 20,
};

const Jump = function ({ url, style = {} }: IProps) {
  const { t } = useTranslation();

  const finalStyle = {
    ...defaultStyle,
    ...style,
  };

  return (
    <a style={finalStyle} href={url} target="_blank" rel="noreferrer">
      {t("click.get.it")}
    </a>
  );
};

export default Jump;
